import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex h-fit items-center justify-center whitespace-nowrap rounded-[32px] transition-colors focus-visible:outline-hidden disabled:cursor-not-allowed border",
  {
    variants: {
      primary: {
        default:
          "bg-primary-darker1 border-transparent text-text-7 hover:bg-primary-darker2 focus:bg-primary-darker2 active:bg-primary disabled:opacity-50 disabled:bg-primary",
        outline:
          "bg-transparent text-primary border-primary hover:bg-primary-darker2 hover:border-transparent hover:text-text-7 focus:bg-primary-darker2 focus:border-transparent focus:text-text-7 active:bg-primary active:border-transparent active:text-text-7 disabled:opacity-50 disabled:border-primary disabled:text-primary",
        ghost:
          "bg-transparent border-transparent text-primary hover:text-primary-darker2 hover:border-primary-darker2 focus:text-primary-darker2 focus:border-primary-darker2 active:text-primary active:border-primary disabled:opacity-50 disabled:text-primary disabled:border-transparent",
      },
      secondary: {
        default:
          "bg-secondary-darker2 text-text-7 hover:bg-secondary-darker1 focus:bg-secondary-darker1 active:bg-secondary disabled:opacity-50 disabled:bg-secondary border-transparent",
        outline:
          "bg-transparent text-secondary-darker2 border-secondary-darker2 hover:bg-secondary-lighter1 hover:border-transparent hover:text-text-7 focus:bg-secondary-lighter1 focus:border-transparent focus:text-text-7 active:bg-secondary active:border-transparent active:text-text-6 disabled:opacity-50 disabled:border-secondary",
        ghost:
          "bg-transparent border-transparent text-secondary-darker2 hover:text-secondary hover:border-secondary focus:text-secondary focus:border-secondary active:text-secondary active:border-secondary disabled:opacity-50 disabled:text-secondary disabled:border-transparent",
      },
      dark: {
        default:
          "bg-black text-text-7 hover:bg-primary-darker2 focus:bg-primary-darker2 active:bg-background-3 disabled:opacity-50 disabled:bg-black border-transparent",
        outline:
          "bg-transparent text-text-1 border-border-1 hover:bg-primary-darker2 hover:text-text-7 focus:text-text-7 hover:border-transparent focus:bg-primary-darker2 focus:border-transparent active:bg-background-3 active:border-transparent disabled:opacity-50",
        outlineLight:
          "bg-transparent text-text-1 border-border-5 hover:bg-primary-darker2 hover:border-transparent focus:bg-primary-darker2 focus:border-transparent active:bg-background-3 active:border-transparent disabled:opacity-50 disabled:border-border-5",
        ghost:
          "bg-transparent border-transparent text-text-1 hover:border-border-1 focus:border-border-1 active:border-border-3 disabled:opacity-50 disabled:border-transparent",
      },
      light: {
        default:
          "bg-white text-text-1 hover:bg-primary-darker2 focus:bg-primary-darker2 active:bg-primary disabled:opacity-50 disabled:bg-white border-transparent",
        outline:
          "bg-transparent text-text-7 border-border-7 hover:bg-primary-darker2 hover:border-transparent focus:bg-primary-darker2 focus:border-transparent active:bg-primary active:border-transparent disabled:opacity-50",
        outlineLight:
          "bg-transparent text-text-6 border-border-7/50 hover:bg-primary-darker2 hover:border-transparent focus:bg-primary-darker2 focus:border-transparent active:bg-primary active:border-transparent disabled:opacity-50",
        ghost:
          "bg-transparent border-transparent text-text-7 hover:text-primary-darker2 hover:border-border-4 focus:text-primary-darker2 focus:border-border-4 active:text-primary active:border-border-4 disabled:opacity-50 disabled:text-text-7 disabled:border-transparent",
      },
      error: {
        default:
          "bg-error text-white hover:bg-error focus:bg-error active:bg-error disabled:opacity-50 disabled:bg-error border-transparent",
        outline:
          "bg-transparent text-error border-error hover:bg-error hover:text-white hover:border-error focus:bg-error focus:text-white focus:border-error active:bg-error active:text-white disabled:opacity-50",
        ghost:
          "bg-transparent border-error text-error hover:text-error focus:text-error active:text-error disabled:opacity-50",
      },
      dropdownItem: {
        default:
          "bg-transparent font-normal border-transparent rounded-lg text-tny text-text-3 hover:bg-background-6 focus:bg-background-6 active:bg-background-7 active:font-semibold active:text-text-1 w-full justify-start",
      },
      size: {
        extraSmall: "py-1 px-2 text-button-text-sm",
        small: "py-2 px-3 text-button-text-sm",
        normal: "py-3 px-5 text-button-text-md",
        unPadded: "p-0",
        item: "py-2 px-3",
      },
      hasError: {
        true: "border-error!",
      },
    },
    defaultVariants: {
      size: "small",
    },
  }
);
